const makeNbsp = (str: unknown) => (typeof str === 'string' ? str.replace(/\s/g, `&nbsp;`) : '');

export default makeNbsp;
